import NS from 'src/ns';
import $ from 'jquery';
import matchMedia from 'src/utility/matchMedia';
import debounce from 'lodash/debounce';
import chunk from 'lodash/chunk';
import forEach from 'lodash/forEach';
import assign from 'lodash/assign';


class FlatHeight {
  constructor(setting) {
    this.ns = '.stl-FlatHeight';
    this.setting = setting;
    this.$target = $(this.setting.selector);
    this.settingKey = null;
    this.column = null;
  }

  init() {
    this.addEvent();
  }

  addEvent() {
    for (let key in this.setting.mediaQueries) {
      matchMedia.register(key, {
        onMatch: function() {
          this.watch(key);
        }.bind(this),
        onUnMatch: function() {
          this.unWatch();
          this.resetHeight();
        }.bind(this)
      });
    }
  }

  watch(settingKey) {
    this.settingKey = settingKey;

    this.flatHeight();

    $(window)
      .on('resize' + this.ns, debounce(this.flatHeight.bind(this), 300));
  }

  unWatch() {
    $(window)
      .off('resize' + this.ns);
  }

  flatHeight() {
    if (!matchMedia.getMatches(this.settingKey)) {
      return;
    }

    let columnArray = chunk(this.$target, this.setting.mediaQueries[this.settingKey].column);

    forEach(columnArray, (column) => {
      this.setHeight(column, this.getMaxHeight(column));
    });
  }

  getMaxHeight(column) {
    let $target;
    let maxHeight = 0;
    let elmOuterHeight = 0;

    forEach(column, (elm) => {
      $target = $(elm);

      $target.css({
        'min-height': ''
      });

      elmOuterHeight = $target.outerHeight();

      if (elmOuterHeight > maxHeight) {
        maxHeight = elmOuterHeight;
      }
    });

    return maxHeight;
  }

  setHeight(column, height) {
    $(column).css({
      'min-height': height + 'px'
    });
  }

  resetHeight() {
    let $target = this.$target;

    if ($target.length) {
      $target.css({
        'min-height': ''
      });
    }
  }
}

assign(FlatHeight, {
  create: function(setting) {
    if (!setting) return;

    new FlatHeight(setting).init();
  }
});

export default NS.FlatHeight = FlatHeight;


// WEBPACK FOOTER //
// ./htdocs/assets/src/javascripts/utility/flatHeight.js